import { Card } from './Card';
import { CardSection } from './CardSection';
import { CardTitle } from './CardTitle';

Card.Section = CardSection;
Card.Title = CardTitle;

export { Card };
